import React from 'react';

// A slim blueprint / measurement strip used as a texture break between sections.
const TickStrip = ({ label = 'EMPAX · STUDIO' }) => (
  <div className="relative overflow-hidden border-y border-[var(--border)]" style={{ backgroundColor: 'var(--bg-2)' }}>
    <div className="hidden max-w-[1500px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
      {/* measurement ticks */}
      <div className="hidden items-end gap-2 h-6 flex-1 overflow-hidden opacity-60">
        {Array.from({ length: 60 }).map((_, i) => (
          <span
            key={i}
            className="w-px shrink-0"
            style={{
              height: i % 5 === 0 ? '20px' : '10px',
              backgroundColor: i % 5 === 0 ? 'var(--accent-blue)' : 'var(--muted-2)',
            }}
          />
        ))}
      </div>
      <div className="flex items-center gap-4 pl-6 shrink-0">
        <img src="/favicon-x.png" alt="" aria-hidden="true" className="w-3.5 h-3.5" />
        <span className="label  !text-[var(--muted-2)]">{label}</span>
      </div>
    </div>
  </div>
);

export default TickStrip;
